module.exports = __webpack_public_path__ + "img/twitter.77e9e0fa.svg";